import { render, staticRenderFns } from "./CategoriasView.vue?vue&type=template&id=71727b94&"
import script from "./CategoriasView.vue?vue&type=script&lang=js&"
export * from "./CategoriasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports